import { tokenDistributor } from "./index";

export function isTokenExpired() {
  const expiry = parseInt(localStorage.getItem("token_expiry_minutes"), 10);
  const current = Math.floor(Date.now() / 60000);

  if (isNaN(expiry)) return true; // missing or invalid expiry

  const expired = current >= expiry;
  // console.log(
  //   `[Token Check] Now: ${current}, Expiry: ${expiry}, Expired: ${expired}`
  // );
  return expired;
}

export async function fetchAndStoreBearerToken() {
  // console.log("🔄 Fetching new token...");

  const response = await fetch(tokenDistributor, {
    method: "GET",
    headers: {
      "x-sndk-gateway-object-id":
        "YzNaakxYTjJZeTEzZEdJdGFXNTBRSE5oYm1ScGMyc3VZMjl0",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*", 
    },
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Token fetch failed: ${response.status} - ${text}`);
  }

  const data = await response.json();
  const token = data.tokenId;

  const rawExpiry = data.expiryOn || 1439;
  let expiryMinutes = parseInt(
    localStorage.getItem("token_expiry_minutes"),
    10
  );

  // If not already stored, calculate and store expiryMinutes
  if (isNaN(expiryMinutes)) {
    let parsedMinutes = null;

    // Try to extract ISO timestamp from rawExpiry (e.g., "29238065 2025-08-05T05:05:23.1152381Z")
    const isoPart = rawExpiry.split(" ").find((part) => part.includes("T"));

    if (isoPart) {
      const date = new Date(isoPart);
      if (!isNaN(date)) {
        parsedMinutes = Math.floor(date.getTime() / 60000);
      } else {
        console.warn("⚠️ Invalid ISO date:", isoPart);
      }
    }

    // Fallback to 24 hours from now if parsing fails
    if (!parsedMinutes) {
      const currentMinutes = Math.floor(Date.now() / 60000);
      parsedMinutes = currentMinutes + 1439;
      console.warn("⚠️ Using fallback expiry time (24 hours).");
    }

    expiryMinutes = parsedMinutes;
    localStorage.setItem("token_expiry_minutes", expiryMinutes.toString());
  } 

  // Always store or update the token
  localStorage.setItem("bearer_token", token);

  // Check remaining time
  const nowMinutes = Math.floor(Date.now() / 60000);
  const remainingMinutes = Math.max(0, expiryMinutes - nowMinutes);
  const remainingHours = (remainingMinutes / 60).toFixed(2);
  const expired = nowMinutes >= expiryMinutes;
  return token;
}
let tokenPromise = null;

export async function getValidBearerToken() {
  const token = localStorage.getItem("bearer_token");

  if (!token || isTokenExpired()) {
    if (!tokenPromise) {
      tokenPromise = fetchAndStoreBearerToken().finally(() => {
        tokenPromise = null;
      });
    }
    return await tokenPromise;
  }
  return token;
}

export async function initializeTokenManagement() {
  const expired = isTokenExpired(); // ✅ single call
  if (expired) {
    await fetchAndStoreBearerToken();
  }

  // schedule next refresh
  const expiry = parseInt(localStorage.getItem("token_expiry_minutes"), 10);
  const current = Math.floor(Date.now() / 60000);
  const delayMs = (expiry - current - 1) * 60 * 1000;
  setTimeout(initializeTokenManagement, delayMs > 0 ? delayMs : 5 * 60 * 1000);
}
